export function serializeConversation(messages) {
  return (messages || [])
    .filter((m) => m.role === "user" || m.role === "assistant")
    .filter((m) => typeof m.content === "string" && m.content.trim())
    .map((m) => ({ role: m.role, content: m.content.trim().slice(0, 2000) }))
    .slice(-50);
}

/**
 * Ticket subject/message must be the problem typed after "What happened?",
 * never an earlier FAQ question. Conversation keeps the prior chat for context.
 */
export function buildEscalationTicket({ priorMessages, problem, category }) {
  const text = String(problem || "").trim();
  const history = serializeConversation([
    ...(priorMessages || []),
    { role: "user", content: text },
  ]);
  return {
    category: category || "Something Else",
    subject: text.slice(0, 80),
    message: text,
    conversation: history,
  };
}
